import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const SkeletonLoader = () => {
    return (

        <Container className="p-4 rounded  skelton-main" >
            <div style={{margin:'17px'}}>
                <Row className="mb-3">
                    <Col xs={6}><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                    <Col xs={6}><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={6}><div className="bg-custom rounded skeleton-wave" style={{ height: "50px"}}></div></Col>
                    <Col xs={6}><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={4}><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="mb-3">
                    <Col><div className="bg-custom rounded skeleton-wave" style={{ height: "50px" }}></div></Col>
                </Row>
                <Row className="justify-content-center">
                    <Col xs={7}><div className=" rounded skeleton-wave w-100 loginsubmit btn btn-primary" style={{ height: "50px" }}></div></Col>
                </Row>
            </div>
        </Container>
    );
};

export default SkeletonLoader;